import classNames from 'classnames'

import Image from '../ui/Image/Image'
import styles from './Paginator.module.scss'
// import rightArrow from '../../assets/images/rightArrow.svg'
// import disabledLeftArrow from '../../assets/images/disabledLeftArrow.svg'
import arrowUpRight from '../../assets/images/arrowUpRight.svg'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isArabic } from '../../utils'

const Paginator = ({ currentPage, setCurrentPage, numOfPage, className }) => {
  const numArray = [...Array(numOfPage + 1).keys()].slice(1)
  const { language } = useLanguage()

  const prevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const nextPage = () => {
    if (currentPage !== numOfPage) {
      setCurrentPage(currentPage + 1)
    }
  }

  const changePage = (id) => {
    setCurrentPage(id)
  }

  return (
    <div
      className={classNames(
        'flex flex-row items-center',
        styles.container,
        className
      )}
    >
      <button
        aria-label="Previous Button"
        className={styles.prevButton}
        onClick={prevPage}
      >
        <Image
          src={arrowUpRight}
          className={classNames(
            isArabic(language?.code) ? 'rotate45' : 'rotate225',
            {
              ['filter-opacity']: currentPage === 1,
            }
          )}
          alt="prev"
        />
      </button>
      <div className={classNames(styles.numberContainer)}>
        {numArray.map((num) => {
          return (
            <button
              key={'page' + num}
              aria-label={`Go to page ${num}`}
              className={classNames(styles.number, {
                [styles.active]: currentPage === num,
              })}
              onClick={() => changePage(num)}
            >
              {num}
            </button>
          )
        })}
      </div>
      <button
        aria-label="Next Button"
        className={styles.nextButton}
        onClick={nextPage}
      >
        <Image
          src={arrowUpRight}
          className={classNames(
            isArabic(language?.code) ? 'rotate225' : 'rotate45',
            {
              ['filter-opacity']: currentPage === numOfPage,
            }
          )}
          alt="next"
        />
      </button>
    </div>
  )
}

export default Paginator
